export default __webpack_public_path__ + "static/aws-data-analytics-solutions-e184a57f9fefca48875f7e4fb1379948.jpg";